import { fileToDataUri } from '../../../helpers/files';

/**
 * Retrieves the preview of a file.
 * @param file - The file to retrieve the preview for.
 * @returns A Promise that resolves to the URL of the file preview.
 */
export const getPreview = async (file: File): Promise<string | undefined> => {
  // Image
  if (file.type.startsWith('image') && file.size > 0) {
    const url = await fileToDataUri(file);
    return url;
  }

  return undefined;
};
